import { render, staticRenderFns } from "./UiComponents.vue?vue&type=template&id=31a5a86d&scoped=true"
import script from "./UiComponents.vue?vue&type=script&lang=js"
export * from "./UiComponents.vue?vue&type=script&lang=js"
import style0 from "./UiComponents.vue?vue&type=style&index=0&id=31a5a86d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a5a86d",
  null
  
)

export default component.exports